import React, { useEffect, useState } from 'react';
import NumberFlow from '@number-flow/react'
import Fade from '@mui/material/Fade';
import Chip from '@mui/material/Chip';

export default function Intro({ pageValue, startChange }) {

    const [kpiOne, setKpiOne] = useState(5000000)
    const [kpiTwo, setKpiTwo] = useState(5000000)

    const [quoteOne, setQuoteOne] = useState(false)
    const [quoteTwo, setQuoteTwo] = useState(false)

    const [lineOne, setLineOne] = useState(false)
    const [lineOneSwitch, setLineOneSwitch] = useState(false)
    const [lineTwo, setLineTwo] = useState(false)
    const [lineThree, setLineThree] = useState(false)
    const [lineFour, setLineFour] = useState(false)

    const [catOne, setCatOne] = useState(false)
    const [catTwo, setCatTwo] = useState(false)
    const [catThree, setCatThree] = useState(false)

    useEffect(() => {
        // Display main quotes
        setTimeout(() => {
            setQuoteOne(true)
        }, 1000);
        setTimeout(() => {
            setQuoteTwo(true)
        }, 3500);
        // Decrease main kpi number gradually
        setTimeout(function () {
            setKpiTwo(1000000)
        }, 6000);
        setTimeout(function () {
            setKpiTwo(100000)
        }, 7500);
        setTimeout(function () {
            setKpiTwo(100)
        }, 8500);
        setTimeout(function () {
            setKpiTwo(0)
        }, 9500);
        // Display secondary quotes
        setTimeout(() => {
            setLineOne(true)
        }, 10000);
        // setTimeout(() => {
        //     setLineOneSwitch(true)
        // }, 11800);
        
        setTimeout(() => {
            setCatOne(true)
            setLineTwo(true)
        }, 11000);
        setTimeout(() => {
            setCatTwo(true)
            setLineThree(true)
        }, 12300);
        setTimeout(() => {
            setCatThree(true)
            setLineFour(true)
        }, 13300);
        // // Display cats after final quote
        // setTimeout(() => {
        //     setCatOne(true)
        // }, 9400);
        // setTimeout(() => {
        //     setCatTwo(true)
        // }, 10500);
        // setTimeout(() => {
        //     setCatThree(true)
        // }, 11000);
    }, []);

    return (
        <div className="introContainer">
            <div className="frameContainer">
                <Fade in={true} timeout={1500}>
                    <img className="frame" src={"../images/frame.png"} ></img>
                </ Fade>

                <img className="intro_buttons" src={"../images/like_1.png"} style={{ right: "90px", animationName: "like_1" }}></img>
                <img className="intro_buttons" src={"../images/like_2.png"} style={{ right: "92px", bottom: "-95px", height: "54px", width: "54px", animationName: "like_2" }}></img>
                <img className="intro_buttons" src={"../images/like_3.png"} style={{ right: "36px", height: "55px", width: "55px", animationName: "like_3" }}></img>

                <img className="intro_buttons" src={"../images/pass_1.png"} style={{ left: "90px", animationName: "pass_1" }}></img>
                <img className="intro_buttons" src={"../images/pass_2.png"} style={{ left: "92px", bottom: "-95px", height: "54px", width: "54px", animationName: "pass_2" }}></img>
                <img className="intro_buttons" src={"../images/pass_3.png"} style={{ left: "36px", height: "55px", width: "55px", animationName: "pass_3" }}></img>

                <div className="quote">
                    <div className="introLine">

                        <Fade in={quoteOne} timeout={2000}>
                            <div style={{ width: "100%" }}>
                                <NumberFlow
                                    className="introKPI"
                                    value={kpiOne}
                                    spinTiming={{ duration: 1050 }}
                                />
                                <h1 className="introH1">The adult population of NYC</h1>
                            </div>
                        </ Fade>

                        <Fade in={quoteTwo} timeout={2000}>
                            <div style={{ width: "100%" }}>
                                <NumberFlow
                                    className="introKPI"
                                    value={kpiTwo}
                                    isolate={false}
                                    suffix={kpiTwo === 0 ? "?":""}
                                />
                                <h1 className="introH1" style={{fontSize: "18px"}}>Your dating pool size after factoring in your criteria for a partner</h1>
                            </div>
                        </ Fade>
                    </div>

                    <div className="introLineTwo" style={{
                        position: "relative",
                        left: catTwo ? "30px" : "0px"
                    }}>
                        
                        <Fade in={lineOne} timeout={800}>
                            <div>
                                <h2 className="introH2">This is a...</h2>
                                {/* {lineOneSwitch ? <h2 className="introH2">This is a...</h2> : <h2 className="introH2">This isn't a dating app</h2>} */}
                            </div>
                        </ Fade>

                        <Fade in={lineTwo} timeout={1000}>
                            <div>
                                <h2 className="introH2">- dating pool calculator 🤖</h2>
                            </div>
                        </ Fade>

                        <Fade in={lineThree} timeout={1000}>
                            <div>
                                <h2 className="introH2">- introspection aid 💭</h2>
                            </div>
                        </ Fade>


                        <Fade in={lineFour} timeout={1000}>
                            <div>
                                <h2 className="introH2">- call to action ⚡️</h2>
                            </div>
                        </ Fade>
                    </div>
                </div>

                <Fade in={quoteOne} timeout={2000}>
                    <div className="startButton">
                        <Chip variant="outlined" label="START"
                            onClick={(event) => { startChange(1); }}
                            sx={{
                                "&.MuiChip-root": {
                                    border: catThree ? "1px solid rgba(0, 0, 0, 1)" : "1px solid rgba(0, 0, 0, 0.10)",
                                    borderRadius: "20px", height: "auto", padding: "5px"
                                    // , borderColor: pageValue === 1 ? "#9F9F9F" : "#E6E6E6"
                                    , backgroundColor: catThree ? "rgba(0, 0, 0, 0.80)" : "rgba(255, 255, 255, 0)"
                                    , width: "150px"
                                    , height: "40px"
                                    , borderRadius: "50px"
                                    , transition: "2s"
                                }
                                , "&.MuiChip-root:hover": {
                                    backgroundColor: "rgba(0, 90, 163, 0.9)"
                                    // backgroundColor: pageValue === 1 ? "#FFFFFF" : "#FFFFFF"
                                }
                                , "& .MuiChip-label": {
                                    color: catThree ? "#FFFFFF" : "rgba(0, 0, 0, 0.10)",
                                    fontSize: "18px",
                                    fontFamily: "Bellota Text, serif",
                                    fontWeight: "600"
                                    , transition: "2s"
                                    //  padding: "0 6px 0 10px"
                                }
                            }}
                        />
                    </div>
                </ Fade>

                <Fade in={true} timeout={1500}>
                    <img className="frame_bg" src={"../images/frame_bg.png"}></img>
                </ Fade>

                <div className="imgWrapperIntro"
                    style={{
                        right: "208px"
                        , bottom: "-22px"
                        , rotate: "8deg"
                        , zIndex: "3"
                        , display: catOne ? "block" : "none"
                        , animationName: catOne ? "peakAnimation" : "none"
                    }}>
                    <img src={"../images/calico.png"} className="catImgCriteriaIntro"></img>
                </div>

                <div className="imgWrapperIntro"
                    style={{
                        right: "215px"
                        , bottom: "45px"
                        , rotate: "17deg"
                        , zIndex: "2"
                        , display: catTwo ? "block" : "none"
                        , animationName: catTwo ? "peakAnimation" : "none"
                    }}>
                    <img src={"../images/orange.png"} className="catImgCriteriaIntro"></img>
                </div>

                <div className="imgWrapperIntro"
                    style={{
                        right: "210px"
                        , bottom: "123px"
                        , rotate: "18deg"
                        , zIndex: "1"
                        , display: catThree ? "block" : "none"
                        , animationName: catThree ? "peakAnimation" : "none"
                    }}>
                    <img src={"../images/tabby.png"} className="catImgCriteriaIntro"></img>
                </div>

            </div>
        </div>
    )
}